import { select, put, call } from 'redux-saga/effects'
import WorkflowActions from '../reducers/workflowRedux'
import ProductActions from '../reducers/productsRedux'

export function* getAddOnProducts(api, action) {
    var response = yield call(api.getEligibleAddOnProducts, action);

    if(response && response.ok)
    {
        yield put(ProductActions.setAddOnProducts(response.data))
    }
}

export function* savePOMSelection(api, workflowApi, action) {
    yield put(ProductActions.setSelectionSaved(false))
    var saveResponse = yield call(api.savePOMSelection, action);
    var caseState = yield call(workflowApi.getWorkflowState)
    if (caseState && caseState.ok) {
        yield put(WorkflowActions.storeCaseState(caseState.data))
        if (saveResponse && saveResponse.ok) {
            yield put(ProductActions.setSelectionSaved(true))
        }
    }
}


